module.exports = __webpack_public_path__ + "img/header-title-img2.6fda3b55.png";